import Vue from 'vue';
import Link from '@/components/Link';

export default () => {
    Vue.component('Link', Link);
};
